export const environment = {
    production: false,
    BASE_URL: "https://dev.speedkdo.com/api/",
    SEARCH_BASE_URL: 'https://nominatim.openstreetmap.org',
    KEY: "V0SPL8bp75PVum9wfONvWh2dqy/OtofxUCJfNPxuqkU="
};
